var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 5.27581V15.6199C19 16.0482 18.6756 16.3958 18.2759 16.3958C17.8761 16.3958 17.5517 16.0482 17.5517 15.6199V7.14917L6.2357 19.2725C6.09473 19.4235 5.90932 19.5 5.72394 19.5C5.53855 19.5 5.35314 19.4245 5.21218 19.2725C4.92927 18.9694 4.92927 18.478 5.21218 18.1749L16.5282 6.05162H8.62053C8.2208 6.05162 7.89638 5.70406 7.89638 5.27581C7.89638 4.84756 8.2208 4.5 8.62053 4.5H18.2759C18.3705 4.5 18.4642 4.5208 18.5531 4.56011C18.7298 4.63872 18.8707 4.78975 18.9451 4.98008C18.9808 5.07421 19 5.17444 19 5.27581Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.6fd7e6603c55f763a3997fa31272eabb.svg";
export { ForwardRef as ReactComponent };